<template>
  <component
    :is="teaserItem.url ? 'a' : 'div'"
    class="box-insertion-teaser-item"
    :class="teaserItem.url ? 'box-insertion-teaser-item--linkable' : false"
    :href="teaserItem.url ? teaserItem.url : false"
    :target="teaserItem.target ? teaserItem.target : false"
  >
    <div class="item">
      <span
        :class="[
          `item__icon item__icon--${teaserItem.icon}`
        ]"
      />
      <div class="item__text-wrapper">
        <span
          class="text-wrapper__header"
          v-if="teaserItem.headline"
          v-html="teaserItem.headline"
        />
        <span
          class="text-wrapper__text"
          v-if="teaserItem.text"
          v-html="teaserItem.text"
        />
      </div>
    </div>
  </component>
</template>

<script>
  export default {
    props: {
      teaserItem: {
        type: Object
      }
    },
  };

</script>
